import { DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAccruedSettlementReport extends Layout {
    excludabletextboxPayee: ExcludableTextbox;
    sourceAccruedSettlement: DataSource;
    switchReportType: Switch;
    textboxCutoffDate: Textbox;
    textboxPayeeType: Textbox;
}
